/**
 * Só leitura: guarda o maior visualViewport.offsetTop visto na sessão (aba),
 * para o Diagnóstico mostrar se o deslocamento do WebKit 297779 aconteceu.
 */
const KEY = 'autofluxo_vv_offset_max';
let started = false;

export function getMaxViewportOffsetTop(): number {
  try { return Number(sessionStorage.getItem(KEY)) || 0; } catch { return 0; }
}

export function startViewportOffsetTracker(): void {
  if (started || typeof window === 'undefined') return;
  const vv = window.visualViewport;
  if (!vv) return;
  started = true;
  const check = () => {
    const v = Math.round(vv.offsetTop);
    if (v > getMaxViewportOffsetTop()) {
      try { sessionStorage.setItem(KEY, String(v)); } catch { /* opcional */ }
    }
  };
  check();
  vv.addEventListener('resize', check);
  vv.addEventListener('scroll', check);
  window.addEventListener('scroll', check, { passive: true, capture: true });
}
